<template>
  <div class="user-manager">
    <div class="search-box">
      <p>
        <span>用户账号：</span>
        <a-input v-model="account"></a-input>
      </p>
      <p>
        <span>用户昵称：</span>
        <a-input v-model="nickName"></a-input>
      </p>
      <a-button @click="search">搜索</a-button>
    </div>
    <a-table
        :dataSource="list"
        rowKey="id"
        :loading="loading"
        :pagination="false">
      <a-table-column
          title="賬號"
          align="center"
          dataIndex="account"></a-table-column>
      <a-table-column
          align="center"
          title="暱稱"
          dataIndex="nickName"></a-table-column>
      <a-table-column
          align="center"
          title="备注名">
        <template slot-scope="row,item">
          <div v-if="!item.showRemark">
            <p style="color:#ff3656;font-weight: 500;">{{ item.userRemark ? item.userRemark : '未设置' }}</p>
            <a-button size="small" v-if="item.userRemark" @click="editRemark(item)">编辑</a-button>
            <a-button size="small" v-else @click="editRemark(item)">设置</a-button>
          </div>
          <div v-if="item.showRemark">
            <a-input style="width:100px;" v-model="item.userRemark"></a-input>
            <a-button type="primary" size="small" style="margin-left:10px;" @click="subRemark(item)">提交</a-button>
            <a-button type="primary" size="small" style="margin-left:10px;" @click="cancelRemark(item)">取消</a-button>
          </div>
        </template>
      </a-table-column>
      <a-table-column
          title="密碼"
          align="center"
          dataIndex="password"></a-table-column>
      <a-table-column
          align="center"
          title="創建時間">
        <template slot-scope="item,row,index">
          {{ row.addTime | trans-date }}
        </template>
      </a-table-column>
      <a-table-column
          align="center"
          title="会员到期時間">
        <template slot-scope="item,row,index">
          <span v-if="row.vipEndTime">{{ row.vipEndTime | trans-date }}</span>
          <span v-else>未知</span>
        </template>
      </a-table-column>
      <a-table-column
          align="center"
          title="會員類型">
        <template slot-scope="item,row,index">
          <span v-if="row.vipDesc" style="color:#ff4499;">{{ row.vipDesc }}</span>
          <span v-else>註冊用戶</span>
        </template>
      </a-table-column>
      <a-table-column
          align="center"
          title="操作">
        <template slot-scope="row,item,index">
          <a-space>
            <a-button size="small" @click="del(item)">刪除</a-button>
            <a-button size="small" :loading="item.loading" :disabled="item.loading" @click="showVip(item)">設置會員
            </a-button>
          </a-space>
        </template>
      </a-table-column>
    </a-table>
    <a-pagination :defaultPageSize="para.pageSize" :defaultCurrent="para.pageIndex" :total="total"
                  @change="currentChange"/>
    <a-modal
        title="添加賬號"
        :visible="showAdd"
        @ok="action"
        :confirmLoading="loading"
        @cancel="hideAdd"
    >
      <a-form>
        <a-form-item
            label="賬號名稱"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
        >
          <a-input placeholder="請輸入英文賬號名稱" v-model="username"></a-input>
        </a-form-item>
        <a-form-item
            label="賬號密碼"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
        >
          <a-input placeholder="請輸入賬號密碼" v-model="password"></a-input>
        </a-form-item>
        <a-form-item
            label="賬號暱稱"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
        >
          <a-input placeholder="請輸入賬號暱稱" v-model="nickname"></a-input>
        </a-form-item>
        <a-form-item
            label="賬號到期時間"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
        >
          <a-date-picker v-model="time"/>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
        title="添加賬號"
        :visible="vipShow"
        @ok="subVip"
        :confirmLoading="subLoading"
        @cancel="vipCancel"
    >
      <a-form>
        <a-form-item
            label="選擇會員類型"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
        >
          <a-select v-model="vipType" style="width: 120px">
            <a-select-option :value="item.vipType" v-for="(item,index) in vipList" :key="index">{{ item.vipDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
            label="會員到期時間"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
        >
          <a-date-picker v-model="vipTime"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  data() {
    return {
      account:undefined,
      nickName:undefined,
      showRemark:false,
      userRemark: undefined,
      vipType: undefined,
      subLoading: false,
      username: '',
      nickname: '',
      password: '',
      time: null,
      vipTime: null,
      list: [],
      showAdd: false,
      loading: false,
      editor: false,
      editId: '',
      para: {
        pageIndex: 1,
        pageSize: 10,
        userStatus: 1
      },
      total: 0,
      vipObj: null,
      vipShow: false,
      vipList: false
    }
  },
  methods: {
    search(){
      if(this.account){
        this.para.account = this.account;
      }else{
        delete this.para.account;
      }
      if(this.nickName){
        this.para.nickName = this.nickName;
      }else{
        delete this.para.nickName;
      }
      this.para.pageIndex=1;
      this.getList()
    },
    cancelRemark(item){
      item.showRemark=false;
    },
    editRemark(item) {
      item.showRemark = true;
    },
    subRemark(item) {
      let self=this;
      self.loading=true;
      self.$http({
        method: 'post',
        url: '/manager/user/update',
        data: {
          userId: item.id,
          userRemark:item.userRemark
        }
      }).then(res=>{
        self.$Message.success('操作成功');
        item.loading=false;
        self.getList()
      }).catch(err=>{
        item.loading=false;
      })
    },
    del(item) {
      let self = this;
      this.$Confirm({
        title: '確定刪除該賬號嗎？',
        onOk() {
          self.$http({
            method: 'post',
            url: '/manager/user/delete',
            data: {
              id: item.id
            }
          }).then(function (res) {
            self.$Message.success('操作成功')
            self.getList()
          }).catch(err => {
          })
        },
        onCancel() {
        }
      })
    },
    action() {
      let url, data;
      let self = this;
      if (this.username === '') {
        this.$Message.warning('請輸入用戶名，用戶名不能為中文');
        return false;
      }
      if (this.password === '') {
        this.$Message.warning('請輸入密碼')
        return false;
      }
      if (this.nickname === '') {
        this.$Message.warning('請輸入暱稱')
        return false;
      }
      if (this.editor) {
        url = '/manager/user/update'
        data = {
          account: this.username,
          nickName: this.nickname,
          password: this.password,
          userId: this.editId
        }
      } else {
        url = '/manager/user/add'
        data = {
          account: this.username,
          nickName: this.nickname,
          password: this.password
        }
      }
      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        self.$Message.success('操作成功')
        self.hideAdd();
        self.getList()
      }).catch(err => {
      })
    },
    getList() {
      let self = this;
      this.loading = true;
      this.$http({
        method: 'post',
        url: '/manager/user/list',
        data: self.para
      }).then(function (res) {
        if (res.data.list) {
          res.data.list.forEach(item => {
            item.loading = false;
            item.showRemark=false;
            let time = '';
            let y = new Date(item.vipEndTime).getFullYear();
            let m = new Date(item.vipEndTime).getMonth() + 1;
            let d = new Date(item.vipEndTime).getDate()
            time = y + '-' + m + '-' + d
            item.vipTime = moment(time)
          })
          self.list = res.data.list;
          self.total = res.data.totalRows
        }
        self.loading = false;
      }).catch(err => {
        self.loading = false;
      })
    },
    hideAdd() {
      this.showAdd = false;
      this.username = '';
      this.nickname = '';
      this.password = '';
      this.time = null;
    },
    currentChange(val) {
      this.para.pageIndex = val;
      this.getList();
    },
    showVip(item) {
      this.vipObj = item;
      if (item.vipType) {
        this.vipType = item.vipType;
        this.vipTime = item.vipTime;
      }
      let self = this;
      item.loading = true;
      self.$http({
        method: 'post',
        url: '/manager/vip/list',
      }).then(function (res) {
        item.loading = false;
        self.vipList = res.data;
        self.vipShow = true;
      }).catch(err => {
        self.loading = false;
        self.$Message.error(JSON.stringify(err))
      })
    },
    subVip() {
      let self = this;
      if (!this.vipType) {
        this.$Message.warning('請選擇會員');
        return false;
      }
      if (!this.vipTime) {
        this.$Message.warning('請選擇到期時間');
        return false;
      }
      this.subLoading = true;
      this.$http({
        method: 'post',
        url: '/manager/user/update',
        data: {
          userId: self.vipObj.id,
          vipEndTime: new Date(self.vipTime).getTime(),
          vipType: self.vipType
        }
      }).then(function (res) {
        self.subLoading = false;
        self.$Message.success('操作成功')
        self.vipCancel();
        self.getList();
      }).catch(err => {
        self.subLoading = false;
      })
    },
    vipCancel() {
      this.vipType = undefined;
      this.vipObj = null;
      this.vipTime = null;
      this.vipShow = false;
    }
  },
  created() {
    this.getList();
    this.$emit('breadcrumbChange', ['賬號管理', '賬號列表'])
  },
}
</script>
<style lang="less">
div.user-manager {
  div.search-box {
    text-align: left;
    display: flex;
    margin-bottom:20px;
    p{
      margin-right:20px;
    }
    input{
      width:140px;
    }
  }
}
</style>